import React from 'react';
import { Package } from '../../types';

interface Props {
  isLoading: boolean;
  packages: Package[];
  selectedPackageId: string | null;
  onSelect: (pkg: Package) => void;
  onAdd: () => void;
  onEdit: (pkg: Package) => void; // Prop mới cho sự kiện Edit
  onDelete: (packageId: string) => void;
}

const PackageListPanel: React.FC<Props> = ({ isLoading, packages, selectedPackageId, onSelect, onAdd, onEdit, onDelete }) => {
  return (
    <div className="studio-list-panel">
      <h3>Packages ({packages.length})</h3>

      {isLoading ? (
        <div className="loading-spinner"></div>
      ) : (
        <>
          <ul className="studio-list">
            {packages.map(pkg => (
              <li
                key={pkg.id}
                className={`studio-list-item ${pkg.id === selectedPackageId ? 'active' : ''}`}
                onClick={() => onSelect(pkg)}
              >
                <span>{pkg.name}</span>
                {/* Nút Edit mới */}

                <div className="item-actions">
                  <button
                    className="btn-edit"
                    onClick={(e) => {
                      e.stopPropagation(); // Ngăn sự kiện onSelect của thẻ li
                      onEdit(pkg);
                    }}
                  >
                    Edit
                  </button>
                  <button className="btn-delete" onClick={(e) => { e.stopPropagation(); onDelete(pkg.id); }}>&times;</button>
                </div>

              </li>
            ))}
          </ul>
          <button className="btn btn-add" onClick={onAdd}>+ New Package</button>
        </>
      )}
    </div>
  );
};

export default PackageListPanel;